import { Typography, Box } from '@mui/material';
import ExcelUploadSection from './ExcelUploadSection';

const DocsRooms = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Classrooms
      </Typography>

      <Typography variant="body1" paragraph>
        Classrooms represent physical spaces where classes are conducted. You
        need to define classrooms before generating timetables to ensure that
        each class has a designated location.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Adding a Classroom
      </Typography>

      <ExcelUploadSection />

      <Typography variant="body1" paragraph>
        To add a new classroom, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Classrooms</strong> section in the
            dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Add</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the department of the classroom.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter the classroom name or number (e.g., Room 101, A-201).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select a <strong>Classroom Type</strong> (e.g., Lecture, Lab,
            Seminar, CSLab, BioLab).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Optionally, specify the strength i.e maximum seating capacity of the
            classroom.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click <strong>Save</strong> to add the classroom.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Managing Classrooms
      </Typography>
      <Typography variant="body1" paragraph>
        Once added, you can manage classrooms through the dashboard:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Editing:</strong> Click on the edit(pencil) button to modify
            classroom details.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Deleting:</strong> Click on the edit(pencil) button and
            select delete if it is no longer needed.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsRooms;
